var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 80,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6467 26.3334H35.3534C33.1374 26.3334 31.3334 28.136 31.3334 30.3534V49.648C31.3334 51.864 33.136 53.668 35.3534 53.668H54.648C56.864 53.668 58.668 51.8654 58.668 49.648V30.3534C58.6667 28.136 56.864 26.3334 54.6467 26.3334ZM57.0587 49.6467C57.0587 50.976 55.9774 52.0587 54.6467 52.0587H35.3534C34.024 52.0587 32.9414 50.9774 32.9414 49.6467V46.7387L39.4294 39.5294L48.1934 47.496L53.04 43.4574L57.06 46.8067L57.0587 49.6467ZM57.0587 44.7147L53.0387 41.3654L48.2374 45.3654L39.316 37.2534L32.9414 44.336V30.3534C32.9414 29.024 34.0227 27.9414 35.3534 27.9414H54.648C55.9774 27.9414 57.06 29.0227 57.06 30.3534L57.0587 44.7147Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.628 38.3921C52.844 38.3921 54.648 36.5894 54.648 34.3721C54.648 32.1547 52.8454 30.3521 50.628 30.3521C48.412 30.3521 46.608 32.1547 46.608 34.3721C46.608 36.5894 48.4107 38.3921 50.628 38.3921ZM50.628 31.9614C51.9574 31.9614 53.04 33.0427 53.04 34.3734C53.04 35.7041 51.9587 36.7854 50.628 36.7854C49.2974 36.7854 48.216 35.7041 48.216 34.3734C48.216 33.0427 49.2974 31.9614 50.628 31.9614Z",
    fill: "#B7B7B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 83,
    height: 73,
    rx: 1.5,
    stroke: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.7cb59748ae245fa66e8609ec2d1b0bdf.svg";
export { ForwardRef as ReactComponent };